import React, { createContext, useContext } from 'react';

const defaultFeatureFlags = {
  isAgentUiEnabled: false
};

export const FeatureFlagsContext = createContext(defaultFeatureFlags);

export const FeatureFlagsProvider = ({ children, value = defaultFeatureFlags }) => (
  <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>
);

export const useFeatureFlags = () => useContext(FeatureFlagsContext);

export const useAgentUiEnabled = () => {
  const { isAgentUiEnabled } = useFeatureFlags();
  return isAgentUiEnabled;
};
